/**
 * DataList cell renderers of the claim charges table, registered once on
 * import with the singleton `dataListWorkflowRegistry` (desktop rows AND the
 * < 768px mobile cards use them):
 *
 * - amounts → `1 800,00 €` (`formatEur`, `null` ⇒ empty cell), bold on the
 *   Total row;
 * - `garantie` → the label as returned, bold « Total » on the Total row.
 */

import { Text } from '@components/base/display';
import { dataListWorkflowRegistry } from '@components/integrated/data-list';

import { formatEur, formatText, type VeosScalar } from '../../utils/format';
import {
  CLAIM_CHARGE_AMOUNT_RENDERER,
  CLAIM_CHARGE_LABEL_RENDERER,
  isClaimChargesTotalRow,
} from './claimChargesConfig';

function renderChargeText(text: string, row: Record<string, unknown>) {
  const total = isClaimChargesTotalRow(row);
  return (
    <Text as="span" size="sm" weight={total ? 'bold' : 'normal'}>
      {text}
    </Text>
  );
}

function asScalar(value: unknown): VeosScalar {
  return typeof value === 'number' || typeof value === 'string' ? value : null;
}

dataListWorkflowRegistry.registerCellRenderer(CLAIM_CHARGE_AMOUNT_RENDERER, (value, row) =>
  renderChargeText(formatEur(asScalar(value)), row),
);

dataListWorkflowRegistry.registerCellRenderer(CLAIM_CHARGE_LABEL_RENDERER, (value, row) =>
  renderChargeText(formatText(asScalar(value)), row),
);
